import { Outlet } from "react-router-dom";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";

import { Tabs } from "minimum-ui/core";
import { Props, useNestedTabs } from "./useNestedTabs";

const NestedTabs: React.FC<Props> = ({ tabs, redirectToFirst }) => {
  const { visibleTabs } = useNestedTabs({ tabs, redirectToFirst });

  return (
    <>
      {visibleTabs.length > 0 && (
        <TabsWrapper>
          <Tabs tabs={visibleTabs} redirectToFirst={redirectToFirst} />
        </TabsWrapper>
      )}
      <Outlet />
    </>
  );
};

const TabsWrapper = styled.div`
  max-width: 100%;
  display: flex;
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid ${color.neutral[200]};
`;

export default NestedTabs;
